export default __webpack_public_path__ + "static/media/no-chart-data.6b4c24be.svg";